var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.updater.newVersionAvailable)?_c('div',{staticClass:"update-message",on:{"click":_vm.update}},[_vm._v("\n  New version is ready, click here to switch!\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }